export default {
  title: 'Invite My Customers',
  tooltip:
    'Incentivize customers to join your rewards program by sending them treats.',
  description:
    'Once completed, Twism will get in touch with you to help you get started.',
  emptyState: {
    title: 'Easily Invite Your Customers to Your Loyalty Program',
    description:
      'Import your customers with a CSV file, and Twism will help you create a personalized invite campaign. Review everything before we send it on your behalf.',
    btn: 'Start inviting your customers now!'
  },
  form: {
    haveLoyalty: 'Do you have an active loyalty program?',
    howThisWork: 'How does that work?',
    howThisWorkPlaceholder:
      'E. g. Earn points with every purchase made through Square, Clover, QU POS, or other partners to unlock rewards in our loyalty program.',
    spreadsheet:
      'Upload a spreadsheet <span class="observation">(Must include customer’s name and email)</span>',
    btn: 'Confirm'
  },
  processing: {
    title: 'Processing your information!',
    description:
      'The set up process is typically completed in 1-3 business days. Twism will notify you via email.'
  }
};
